export default {
  benefits: {
    earn_points: 'Kerää pisteitä jokaisesta tilauksesta',
    get_deals: 'Saat erikoisalennuksia',
    redeem_points: 'Lunasta pisteitä ilmaiseksi ruoaksi',
  },
};
